





























































































































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import DialogWrapper from '@/components/dialogWrapper.vue';
import { Tutor, SearchCondition } from '@/modules/tutor';
import { Subject } from '@/models/subject';
import { SchoolTypes, getSchoolTypeName } from '@/enums/schoolTypes';
import { UserTypes, getUserTypeName } from '@/enums/userTypes';
import { FunctionTypes } from '@/enums/functionTypes';
import { ElForm } from 'element-ui/types/form';
import store from '@/store';

Component.registerHooks([
  'beforeRouteEnter',
]);

@Component
export default class UserList extends Vue {
  private UserTypes = UserTypes;
  private SchoolTypes = SchoolTypes;
  private getUserTypeName = getUserTypeName;
  private getSchoolTypeName = getSchoolTypeName;
  private isEdit = false;
  private showSearchCondition = true;

  private formRule = {
    lastName: [
      { required: true, message: '氏名（姓）を入力してください' },
    ],
    firstName: [
      { required: true, message: '氏名（名）を入力してください' },
    ],
    lastNameKana: [
      { required: true, message: 'カナ（姓）を入力してください' },
      { pattern: '^[ァ-ヶー]*$', trigger: 'blur', message: '全角カタカナを入力してください' },
    ],
    firstNameKana: [
      { required: true, message: 'カナ（名）を入力してください' },
      { pattern: '^[ァ-ヶー]*$', trigger: 'blur', message: '全角カタカナを入力してください' },
    ],
  };

  private deleteFormRule = {
    checkUserName: [
      { required: true, message: '削除する講師名を入力してください' },
      { validator: this.validateCheckUserName, trigger: 'blur' },
    ],
  };

  private validateCheckUserName(rule: any, value: string, callback: any) {
    const userName = ((this.$refs.userDelete as DialogWrapper).form as any).userName;
    if (value.replace(/\s+/g, '') === userName.replace(/\s+/g, '')) {
      callback();
    } else {
      callback(new Error('講師名が異なります'));
    }
  }

  get accountId(): string {
    return this.$store.getters['auth/accountId'];
  }

  get loading(): boolean {
    return this.$store.state.tutor.loading;
  }

  get countAll(): number {
    if (this.$store.state.tutor.countAll === 0) {
      return 1;
    } else {
      return this.$store.state.tutor.countAll;
    }
  }

  get users(): Tutor[] {
    return this.$store.state.tutor.users;
  }

  get condition(): SearchCondition {
    return this.$store.state.tutor.searchCondition;
  }

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  private beforeRouteEnter(to: any, from: any, next: any) {
    switch (store.getters['auth/userType']) {
      case UserTypes.Admin:
      case UserTypes.Owner:
      case UserTypes.AdminTutor:
        next();
        break;
      default:
        next({ name: 'Error' });
        break;
    }
  }

  private mounted() {
    this.loadData();
  }

  private deactivated() {
    this.$destroy();
  }

  private loadData() {
    this.$store.dispatch('tutor/searchTutors', this.condition);
  }

  private getRowNumber(index: number) {
    return this.condition.perPage * (this.condition.page - 1) + index + 1;
  }

  private onChangeCondition() {
    this.condition.page = 1;
    this.loadData();
  }

  private onChangePage() {
    this.loadData();
  }

  private onChangeSort( {prop, order}: any ) {
    if (!prop) {
      this.condition.sort = '';
    } else {
      this.condition.sort = `${prop} ${order}`;
    }
    this.loadData();
  }

  private onPageSizeChange(val: number) {
    this.condition.perPage = val;
  }

  private submitForm() {
    (this.$refs.form as ElForm).validate((valid) => {
      if (valid) {
        (this.$refs.userEdit as DialogWrapper).submit();
      } else {
        return false;
      }
    });
  }

  private async onCreate() {
    this.isEdit = false;

    const form: Tutor = {
      id: '',
      userId: '',
      lastName: '',
      firstName: '',
      lastNameKana: '',
      firstNameKana: '',
      authority: UserTypes.Tutor,
      authorityName: getUserTypeName(UserTypes.Tutor),
      subjectList: new Array<Subject>(),
      schoolTypeList: new Array<number>(),
      note: '',
      schoolId: '',
      schoolName: '',
      availableFunctionbit: 0,
      availableFunctionTypes: new Array<FunctionTypes>(),
    };

    let result: Tutor;
    try {
      result = await (this.$refs.userEdit as DialogWrapper).open({...form}) as Tutor;
    } catch (error) {
      return;
    }

    const fullName = this.getFullName(result.lastName, result.firstName);
    try {
      const createResult = await this.$store.dispatch('tutor/createTutor', result);
      createResult.title = '講師登録完了';

      try {
        await (this.$refs.userCreateResult as DialogWrapper).open({...createResult});
      } catch (error) {
        return;
      }
    } catch (error) {
      this.$notify.error({
        title: '講師登録エラー',
        message: error.message,
        position: 'bottom-right'
      });
      return;
    }

    this.loadData();
  }

  private async onEdit(row: Tutor) {
    this.isEdit = true;

    let form: Tutor;
    try {
      form = await this.$store.dispatch('tutor/getTutor', row.id);
    } catch (error) {
      form = JSON.parse(JSON.stringify(row));
    }

    let result: Tutor;
    try {
      result = await (this.$refs.userEdit as DialogWrapper).open({...form}) as Tutor;
    } catch (error) {
      return;
    }

    const fullName = this.getFullName(row.lastName, row.firstName);
    try {
      await this.$store.dispatch('tutor/editTutor', result);
      this.$notify({
        title: '講師変更完了',
        message: `講師「${fullName}」を変更しました。`,
        position: 'bottom-right'
      });
    } catch (error) {
      this.$notify.error({
        title: '講師変更エラー',
        message: error.message,
        position: 'bottom-right'
      });
    }
  }

  private submitDeleteForm() {
    (this.$refs.deleteForm as ElForm).validate((valid) => {
      if (valid) {
        (this.$refs.userDelete as DialogWrapper).submit();
      } else {
        return false;
      }
    });
  }

  private async onDelete(row: Tutor) {
    const fullName = this.getFullName(row.lastName, row.firstName);

    try {
      const form = {
        userName: fullName,
        checkUserName: '',
      };
      await (this.$refs.userDelete as DialogWrapper).open({...form});
    } catch (error) {
      return;
    }

    try {
      await this.$store.dispatch('tutor/deleteTutor', row.id);
      this.$notify({
        title: '講師削除完了',
        message: `講師「${fullName}」を削除しました。`,
        position: 'bottom-right'
      });
    } catch (error) {
      this.$notify.error({
        title: '講師削除エラー',
        message: error.message,
        position: 'bottom-right'
      });
    }
  }

  private async onResetPassword(row: Tutor) {
    const fullName = this.getFullName(row.lastName, row.firstName);
    try {
      await this.$confirm(`「${fullName}」のパスワードを初期化します。よろしいですか？`, '講師パスワード初期化', {
        confirmButtonText: '初期化',
        cancelButtonText: 'キャンセル',
        type: 'warning'
      });
    } catch (error) {
      return;
    }

    try {
      const result = await this.$store.dispatch('tutor/resetPassword', row.id);
      result.title = 'パスワード初期化完了';

      try {
        await (this.$refs.userCreateResult as DialogWrapper).open({...result});
      } catch (error) {
        return;
      }
    } catch (error) {
      this.$notify.error({
        title: '講師パスワード初期化エラー',
        message: error.message,
        position: 'bottom-right'
      });
    }
  }

  private getFullName(lastName: string, firstName: string) {
    return `${lastName}　${firstName}`;
  }
}
